export const EXPERIMENT_PREFIX = 'event-card-experiment';
export const FOLLOW_SIGNAL_EXPERIMENT = 'X6QS5eNNQv-yvej7Qyeldg';
